export default __webpack_public_path__ + "static/media/icon-copy.47fb4840.svg";